/*****
 * Created with vscode
 * Name : 患者 bar
 * Date : 2020/3/2
 * Author : Bevis Shen
 * Func :
 ******/

<template>
  <div
    class="ill-desp-person arrow-right right-40"
    v-if="linkSession != 1"
    @click="goPatientInform"
  >
    <img src="../../assets/images/jidayi-hospital/icon_user.png" />
    <h2>咨询人</h2>
    <span v-if="user2">{{filterName(user2.name)}}</span>
    <span v-else>去登记</span>
  </div>
</template>

<script>
export default {
  name: 'PatientBar',
  props: {
  },
  data () {
    return {
      linkSession: '' // 是否对接账户体系（如公众号）
    }
  },
  created () {
    this.linkSession = sessionStorage.getItem('LINK-SESSION')
  },
  computed: {
    user2 () {
      return this.$store.getters.token ? this.$store.state.user.userInfo.user : ''
    }
  },
  methods: {
    // 去就诊人信息页
    goPatientInform () {
      if (this.$store.getters.token) {
        this.$router.push({ path: '/patientInform' })
      } else {
        this.goUserReg()
      }
    },
    // 跳转到登录页
    goUserReg () {
      this.$router.push({
        path: '/userReg',
        query: {
          platId: this.$route.query.platId
        }
      })
    },
    // 姓名脱敏处理
    filterName (str) {
      let tempStr = ''

      if (str !== null && str !== undefined) {
        if (str.length < 3) {
          tempStr = '*' + str.substring(1, str.length)
          return tempStr
        } else if (str.length >= 3 && str.length <= 6) {
          tempStr =
            str.substring(0, 1) +
            str.substring(1, str.length - 1).replace(/[\s\S]/gi, '*') +
            str.substring(str.length - 1, str.length)
          return tempStr
        } else if (str.length > 6) {
          tempStr = str.substring(0, 2) + '****' + str.substring(6, str.length)
          return tempStr
        }
      } else {
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/PatientBar.vue